<template>
  <div class="jrm-method-changer plan">
    <div class="jrm-m-c--unit-wrp size-100">
      <div
        class="jrm-m-c--unit"
        :class="{ selected: isSelected }"
      >
        <div class="flex-r">
          <div class="section size-100">
            <div
              class="jrm-rb--option"
              :class="{ selected: isSelected }"
            >
              <div class="jrm-rb--option-rbtn">
                <div class="jrm-rb--option-rbtn-marker" />
              </div>

              <div class="jrm-rb--option-name">
                {{ projectType.name }}
              </div>

              <div class="signup-rb--option-desk">
                {{ projectType.types }}
              </div>
            </div>
          </div>

          <!--<div class="section size-30 txt-algn-r">
            <a
              href="#"
              class="button"
            >
              <div class="text">
                Подробнее
              </div>
            </a>
          </div>-->
        </div>

        <div>
          <br>
          <hr>
          <br>

          {{ projectType.description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectProjectTypeStepItem',
  props: {
    projectType: {
      type: Object,
      required: true
    },
    isSelected: {
      type: Boolean,
      required: true
    }
  }
}
</script>
